import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-rating',
	templateUrl: './input-rating.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class InputRatingComponent implements OnInit {
	
	@Input() isRequired: any | undefined;
	@Input() model: any;
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() maxRating: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.uid = 'cr-' + Date.now();
		this.vm.ratings = new Array(this.vm.maxRating || 5);
	}
	
	onSelectionChange(event: Event, value: number): void {
		const inputElement = event.target as HTMLInputElement;
		inputElement.checked = true;
		this.vm.model = value;
		this.modelChange.emit(value);
	}
}